import React, {useContext} from 'react';
import {CitizenContext} from "../context/citizen-context.jsx";
import CitizenGeneralVehicles from "./citizen-general-vehicles.jsx";

const CitizenVehicles = () => {
    const {citizen, setCitizen} = useContext(CitizenContext);

    const handleArrayItems = (value, target) => setCitizen(prev => ({...prev, [target]: value}));

    return (
        <>
            <CitizenGeneralVehicles
                title={"Veículos"}
                vehicles={citizen.vehicles}
                onChange={(value) => handleArrayItems(value, "vehicles")}
                height={"h-[calc(100vh-200px)]"}
            />
        </>
    );
};

export default CitizenVehicles;